// Generated by TaroBase SDK Generator: 2026-05-01T17:36:41.366Z
// Collection: revenue/$revenueId
// Edits may be overwritten by subsequent runs!

import {
  get, getMany, set, subscribe, getFiles, setFile, runQuery, count, aggregate, transformValues,
  Time, Token, Increment, Address, PublicKey,
  TimeOperation, IncrementOperation, TokenAmount, AddressType,
  TarobaseMetadata, DocumentOperation, FileItem, setMany, formatError,
} from '../db-client';
import type { AggregateResult, AggregateOperation } from '../db-client';

/**
 * Settled revenue ledger. One record per settled session (use sessionId as the document id for idempotency). Service-only create; immutable thereafter.
 */

export interface RevenueRequest {
  sessionId: string;
  appid: string;
  tenantUserId: string;
  amountUsdCents: number | TimeOperation | IncrementOperation | TokenAmount;
  currency: string;
  nativeAmount: string;
  rail: string;
  kind: string;
  txRef: string;
  metadata?: string;
  recordedAt: number | TimeOperation | IncrementOperation | TokenAmount;
  balanceApplicationId?: string;
  sourceUserAccountId?: string;
  payer?: AddressType;
}

export interface RevenueResponse {
  sessionId: string;
  appid: string;
  tenantUserId: string;
  amountUsdCents: number;
  currency: string;
  nativeAmount: string;
  rail: string;
  kind: string;
  txRef: string;
  metadata?: string;
  recordedAt: number;
  balanceApplicationId?: string;
  sourceUserAccountId?: string;
  payer?: string;
  id: string;
  tarobase_created_at: number;
}

/**
 * Build a Revenue operation for use with setMany.
 * @returns A DocumentOperation that can be passed to setMany.
 */
export function buildRevenue(revenueId: string, data?: RevenueRequest): DocumentOperation {
  const doc = data ? transformValues(data) : {};
  return { path: `revenue/${revenueId}`, document: doc };
}

/**
 * Service-only. Backend writes one revenue row per settled session, keyed by sessionId for idempotency. All fields are required and immutable. (Create/Update Single Item)
 * @returns A boolean indicating whether the operation succeeded (true) or failed (false). Always check this value to confirm the write worked.
 */
export async function setRevenue(revenueId: string, data?: RevenueRequest): Promise<boolean> {
  try {
    const transformedData = transformValues(data || {});
    const succeeded = await set(`revenue/${revenueId}`, transformedData);
    return !!succeeded;
  } catch (error) {
    console.error(`Error setting Revenue: ${formatError(error)}`);
    return false;
  }
}

/**
 * 
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
   (Get Single Item)
 */
export async function getRevenue(revenueId: string): Promise<RevenueResponse | null> {
  try {
    const result = await get(`revenue/${revenueId}`);
    return result as RevenueResponse | null;
  } catch (error) {
    console.error(`Error getting Revenue: ${formatError(error)}`);
    return null;
  }
}

/**
 * Subscribes to changes in a single Revenue document. (
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
  )
 */
export function subscribeRevenue(callback: (data: RevenueResponse | null) => void, revenueId: string): Promise<() => Promise<void>> {
  return subscribe(`revenue/${revenueId}`, { // Use the item's basePath
    onData: (data) => {
      callback(data as RevenueResponse | null);
    },
    onError: (error) => {
      console.error(`Error subscribing to Revenue at path '${`revenue/${revenueId}`}': ${formatError(error)}`);
    }
  });
}

/**
 * Get many Revenue items from collection revenue
 
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
  
 */
export async function getManyRevenue(filter: string = ""): Promise<RevenueResponse[]> {
  try {
    const results = await get("revenue", { prompt: filter });
    return Array.isArray(results) ? results as RevenueResponse[] : [];
  } catch (error) {
    console.error(`Error getting Revenue collection at path 'revenue': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in Revenue collection at revenue
 
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
  
 */
export function subscribeManyRevenue(callback: (data: RevenueResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("revenue", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as RevenueResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to Revenue collection at path '${"revenue"}': ${formatError(error)}`);
    }
  });
}

/**
 * Get all Revenue items from collection revenue
 
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
  
 */
export async function getAllRevenue(filter: string = ""): Promise<RevenueResponse[]> {
  try {
    const results = await get("revenue", { prompt: filter });
    return Array.isArray(results) ? results as RevenueResponse[] : [];
  } catch (error) {
    console.error(`Error getting Revenue collection at path 'revenue': ${formatError(error)}`);
    return [];
  }
}

/**
 * Subscribe to changes in Revenue collection at revenue
 
  Read Operation Details: Service, admin, or tenant owner (resolved via tenants/$appid.owner) can read.
  
 */
export function subscribeAllRevenue(callback: (data: RevenueResponse[]) => void, filter: string = ""): Promise<() => Promise<void>> {
  return subscribe("revenue", {
    prompt: filter,
    onData: (data) => {
      callback(Array.isArray(data) ? data as RevenueResponse[] : []);
    },
    onError: (error) => {
       console.error(`Error subscribing to Revenue collection at path '${"revenue"}': ${formatError(error)}`);
    }
  });
}

